$ ->
  return unless Modernizr.inputtypes.date
  $('input[data-date-input]').each (index, input) ->
    $input = $(input)
    $input.val($input.data('date-input')) if $input.data('date-input')
    $input.attr('type', 'date')
